import { Stack } from "@mui/material";
import CardItem from "./CardItem";

export default function CardContainer({ apps, loading }) {

  const data = [ // Formatom del objeto "apps"
    {
      "id": 11,
      "image": "https://sia-general-tst.frba.utn.edu.ar/imagenes/cards/biblioteca.svg",
      "alt": "122",
      "title": "Biblioteca",
      "shortDescription": "Entorno dedicado a la reserva de libros de la biblioteca de la facultad.",
      "subDescription": "Se puede encontrar información, también de bibliografías de otros autores también.",
      "link": "https://biblioteca-tst.frba.utn.edu.ar/opac_principal.php",
      "filiaciones": [
        "Monotributista",
        "Alumno",
        "Docente",
        "No Docente"
      ]
    },
    {
      "id": 12,
      "image": "https://sia-general-tst.frba.utn.edu.ar/imagenes/cards/guaraniAutogestion.svg",
      "alt": "Guaraní-Autogestión",
      "title": "Guaraní-Autogestión",
      "shortDescription": "Una plataforma que permite a los estudiantes realizar trámites y visualizar su historia académica.",
      "subDescription": "De igual manera funciona para los profesores, donde pueden ver sus alumnos, junto con sus otras cursadas.",
      "link": "https://guarani-tst.frba.utn.edu.ar/autogestion/",
      "filiaciones": [
        "Monotributista",
        "Alumno",
        "Docente",
        "No Docente"
      ]
    },
    {
      "id": 13,
      "image": "https://sia-general-tst.frba.utn.edu.ar/imagenes/cards/aulaVirtual.svg",
      "alt": "Aulas virtuales",
      "title": "Aulas virtuales",
      "shortDescription": "Plataforma en línea donde los profesores cargan material educativo para sus alumnos.",
      "subDescription": "Los estudiantes pueden acceder desde cualquier lugar y en cualquier momento.",
      "link": "https://aulasvirtuales-tst.frba.utn.edu.ar/auth/saml2/login.php",
      "filiaciones": [
        "Alumno",
        "Docente"
      ]
    },
    {
      "id": 11,
      "image": "https://sia-general-tst.frba.utn.edu.ar/imagenes/cards/biblioteca.svg",
      "alt": "122",
      "title": "Biblioteca",
      "shortDescription": "Entorno dedicado a la reserva de libros de la biblioteca de la facultad.",
      "subDescription": "Se puede encontrar información, también de bibliografías de otros autores también.",
      "link": "https://biblioteca-tst.frba.utn.edu.ar/opac_principal.php",
      "filiaciones": ["Monotributista", "Alumno", "Docente", "No Docente"]
    },
    {
      "id": 12,
      "image": "https://sia-general-tst.frba.utn.edu.ar/imagenes/cards/guaraniAutogestion.svg",
      "alt": "Guaraní-Autogestión",
      "title": "Guaraní-Autogestión",
      "shortDescription": "Una plataforma que permite a los estudiantes realizar tramites y visualizar su historia académica.",
      "subDescription": "De igual manera funciona para los profesores, donde pueden ver sus alumnos, junto con sus otras cursadas.",
      "link": "https://guarani-tst.frba.utn.edu.ar/autogestion/",
      "filiaciones": ["Monotributista", "Alumno", "Docente", "No Docente"]
    },
    {
      "id": 13,
      "image": "https://sia-general-tst.frba.utn.edu.ar/imagenes/cards/aulaVirtual.svg",
      "alt": "Aulas virtuales",
      "title": "Aulas virtuales",
      "shortDescription": "Plataforma en línea donde los profesores cargan material educativo para sus alumnos.",
      "subDescription": "Los estudiantes pueden acceder desde cualquier lugar y en cualquier momento.",
      "link": "https://aulasvirtuales-tst.frba.utn.edu.ar/auth/saml2/login.php",
      "filiaciones": ["Alumno", "Docente"]
    },
    {
      "id": 14,
      "image": "https://sia-general-tst.frba.utn.edu.ar/imagenes/cards/bolsaDeTrabajo.svg",
      "alt": "Bolsa de trabajo",
      "title": "Bolsa de trabajo",
      "shortDescription": "Portal donde los alumnos pueden acceder a las oportunidades laborales que ofrece la facultad.",
      "subDescription": "Pueden adjuntar su Curriculum Vitae junto con su link a su portfolio para que lo vean los reclutadores.",
      "link": "https://bolsa-tst.frba.utn.edu.ar/postulantePrincipal.php",
      "filiaciones": ["Monotributista", "Alumno", "No Docente"]
    },
    {
      "id": 15,
      "image": "https://sia-general-tst.frba.utn.edu.ar/imagenes/cards/documentacion.svg",
      "alt": "Documentación",
      "title": "Documentación",
      "shortDescription": "Herramienta web donde se encuentran los manuales de usuario junto con otros procedimientos detallados.",
      "subDescription": "También hay archivos donde se explica más acerca de la estructura de la organización TIC.",
      "link": "https://docs-tst.frba.utn.edu.ar/",
      "filiaciones": ["Alumno", "Docente", "Monotributista", "No Docente", "Investigador"]
    },
    {
      "id": 19,
      "image": "https://sia-general-tst.frba.utn.edu.ar/imagenes/cards/becas.svg",
      "alt": "Becas",
      "title": "Becas",
      "shortDescription": "Servicio dedicado a la administración de becas que genera la facultad y agentes externos.",
      "subDescription": "En este sitio se pueden hacer las solicitudes que el alumno, desee o consultar acerca de una beca.",
      "link": "https://becas-tst.frba.utn.edu.ar/",
      "filiaciones": ["Monotributista", "Alumno", "No Docente", "Docente"]
    }
  ]

  return (
    <Stack sx={{ alignItems: "center", justifyContent: "center" }}>
      <Stack
        sx={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          flexWrap: "wrap",
          gap: "50px",
          width: "90%",
        }}
      >
        {!loading && apps.map((info, index) =>
          <CardItem
            key={index}
            info={info}
          />
        )}
      </Stack>
    </Stack>
  );
}